import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-arrow-light-right",
  "use": "svg-arrow-light-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-arrow-light-right\">\n  <path d=\"m24 12.05-.003.002L12.407 24l-.6-.577 10.635-10.957H0v-.83h22.458L11.724.576l.6-.576L24 12.05Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol